// Keep local metering separate from the track transmitted over WebRTC.
export function createMutedCoachTrack(stream) {
  const track = stream.getAudioTracks()[0].clone();
  track.enabled = false;
  return track;
}

export function setCoachListening(run, listening) {
  run.listening = listening;
  run.sendTrack.enabled = listening;
  run.stream.getAudioTracks().forEach((track) => { track.enabled = listening; });
}

export function disposeCoachAudio(run, { preserveSetup = false } = {}) {
  for (const key of ["timeout", "replyTimeout", "disconnectTimeout", "cancelTimeout"]) clearTimeout(run[key]);
  if (!preserveSetup) clearInterval(run.meterTimer);
  run.controller.abort();
  run.audio?.pause();
  if (run.audio) run.audio.srcObject = null;
  run.checkPlayer?.pause();
  if (run.checkPlayer) run.checkPlayer.srcObject = null;
  try { run.checkOscillator?.stop(); } catch {}
  run.checkOutput?.stream?.getTracks().forEach((track) => track.stop());
  run.channel?.close();
  run.sendTrack?.stop();
  run.peer?.close();
  run.channel = null;
  run.sendTrack = null;
  run.peer = null;
  run.audio = null;
  run.wakeLock?.release().catch(() => {});
  run.wakeLock = null;
  if (preserveSetup) {
    run.stream?.getAudioTracks().forEach((track) => { track.enabled = false; });
  } else {
    run.stream?.getTracks().forEach((track) => track.stop());
    run.source?.disconnect();
    run.audioContext?.close().catch(() => {});
  }
}
